// extracted by mini-css-extract-plugin
export default {"jsonPre":"U9DjIIIlqBb44UjXUdtr"};